import { Error } from "@mui/icons-material";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";

export const mostrarPotenciaTotalMenorQuePotenciaMinimaAlert = (potenciaMinima: number | string, onConfirmation?: Function, onClose?: Function) => {
  confirmationDialog.setup({
    onlyConfirm: true,
    content: [
      `Esse módulo só está disponível para projetos a partir de ${potenciaMinima.toLocaleString()} kWp`
    ],
    size: '440px',
    title: "Atenção!",
    yesText: 'OK',
    propagateWhenConfirm: true,
    onClose: () => {
      confirmationDialog.close();
      if (onClose) onClose();
    },
    onConfirmation: () => {
      if(onConfirmation) onConfirmation();
    },
    headerIcon: <Error style={{ color: '#CC8F00' }} />, 
  })
  confirmationDialog.open();
};